(() => {
  const GIFT_VARIANT_ID = 53748470284588;
  const GIFT_HANDLE = 'zayro-first-order-gift';
  const GIFT_PROPERTY = '_zayro_first_customer_gift';
  const baseFetch = window.fetch.bind(window);
  let syncing = false;
  let watcherInstalled = false;

  function rootPath() {
    return window.Shopify?.routes?.root || '/';
  }

  function installGiftStyles() {
    if (document.getElementById('zayro-first-customer-gift-styles')) return;
    const style = document.createElement('style');
    style.id = 'zayro-first-customer-gift-styles';
    style.textContent = `
      html.zayro-first-gift-active .shopify-payment-button,
      html.zayro-first-gift-active shopify-accelerated-checkout,
      html.zayro-first-gift-active .shopify-payment-button__button {
        display: none !important;
      }
    `;
    document.head.append(style);
  }

  function setCampaignActive(active) {
    document.documentElement.classList.toggle('zayro-first-gift-active', Boolean(active));
  }

  function requestUrl(input) {
    try {
      if (typeof input === 'string') return new URL(input, window.location.origin).pathname;
      if (input && typeof input.url === 'string') return new URL(input.url, window.location.origin).pathname;
    } catch (_) {}
    return '';
  }

  async function getGiftAvailability() {
    try {
      const response = await baseFetch(`${rootPath()}products/${GIFT_HANDLE}.js?zayro_gift=${Date.now()}`, {
        method: 'GET',
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
        cache: 'no-store'
      });
      if (!response.ok) return null;
      const product = await response.json();
      const variant = Array.isArray(product?.variants)
        ? product.variants.find((item) => Number(item.id) === GIFT_VARIANT_ID)
        : null;
      if (!variant) return false;
      return Boolean(variant.available);
    } catch (_) {
      return null;
    }
  }

  async function getCart() {
    const response = await baseFetch(`${rootPath()}cart.js?zayro_gift=${Date.now()}`, {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store'
    });
    if (!response.ok) throw new Error('Unable to read cart');
    return response.json();
  }

  async function changeGift(lineKey, quantity) {
    return baseFetch(`${rootPath()}cart/change.js`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ id: lineKey, quantity })
    });
  }

  async function addGift() {
    return baseFetch(`${rootPath()}cart/add.js`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [{
          id: GIFT_VARIANT_ID,
          quantity: 1,
          properties: {
            [GIFT_PROPERTY]: 'First qualifying Zayro order'
          }
        }]
      })
    });
  }

  async function syncFirstCustomerGift() {
    if (syncing) return;
    syncing = true;

    try {
      const cart = await getCart();
      let giftLine = cart.items.find((item) => Number(item.variant_id) === GIFT_VARIANT_ID);
      const hasQualifyingWatch = cart.items.some((item) => Number(item.variant_id) !== GIFT_VARIANT_ID);
      const availability = await getGiftAvailability();

      if (availability === false) {
        setCampaignActive(false);
        if (giftLine) await changeGift(giftLine.key, 0);
        return;
      }

      if (availability === true) setCampaignActive(true);

      if (!hasQualifyingWatch) {
        if (giftLine) await changeGift(giftLine.key, 0);
        return;
      }

      if (giftLine) {
        if (giftLine.quantity !== 1) await changeGift(giftLine.key, 1);
        return;
      }

      const addResponse = await addGift();
      if (!addResponse.ok) {
        if (addResponse.status === 422) setCampaignActive(false);
        return;
      }

      setCampaignActive(true);
    } catch (error) {
      console.warn('Zayro first customer gift sync:', error);
    } finally {
      syncing = false;
    }
  }

  function installFetchWatcher() {
    if (watcherInstalled) return;
    watcherInstalled = true;

    window.fetch = async (...args) => {
      const response = await baseFetch(...args);
      const path = requestUrl(args[0]);

      if (!response.ok || syncing || !path.includes('/cart/')) return response;

      if (path.endsWith('/cart/add.js')) {
        await syncFirstCustomerGift();
      } else if (
        path.endsWith('/cart/change.js') ||
        path.endsWith('/cart/update.js') ||
        path.endsWith('/cart/clear.js')
      ) {
        window.setTimeout(syncFirstCustomerGift, 0);
      }

      return response;
    };
  }

  async function initializeFirstCustomerGift() {
    installGiftStyles();

    const availability = await getGiftAvailability();
    if (availability !== null) setCampaignActive(availability);

    installFetchWatcher();
    await syncFirstCustomerGift();
  }

  document.addEventListener('submit', (event) => {
    const form = event.target.closest?.('form[action*="/cart/add"]');
    if (!form) return;
    window.setTimeout(syncFirstCustomerGift, 500);
    window.setTimeout(syncFirstCustomerGift, 1400);
  }, true);

  window.addEventListener('pageshow', () => {
    window.setTimeout(syncFirstCustomerGift, 0);
  });

  document.addEventListener('shopify:section:load', () => {
    window.setTimeout(syncFirstCustomerGift, 0);
  });

  window.ZayroFirstCustomerGift = {
    sync: syncFirstCustomerGift,
    variantId: GIFT_VARIANT_ID
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeFirstCustomerGift, { once: true });
  } else {
    initializeFirstCustomerGift();
  }
})();
